var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeliveryExpress = function SvgDeliveryExpress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#213D38",
    fillRule: "evenodd",
    d: "M5.987 3.513A2.487 2.487 0 0 0 3.5 6v10.663c0 .75.607 1.357 1.357 1.357h.355a2.77 2.77 0 0 0 5.51 0h6.582a2.77 2.77 0 0 0 5.511 0h.354c.75 0 1.357-.608 1.357-1.357v-3.74c0-.217-.052-.43-.15-.623l-1.89-3.664a2.71 2.71 0 0 0-2.412-1.47h-3.008V6a2.487 2.487 0 0 0-2.487-2.487zM17.261 8.41h2.893c.55 0 1.054.307 1.306.796l1.426 2.765H17.26zm2.799 10.853a1.526 1.526 0 1 0 0-3.053 1.526 1.526 0 0 0 0 3.053M9.493 17.737a1.526 1.526 0 1 1-3.052 0 1.526 1.526 0 0 1 3.052 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3DC869",
    stroke: "#fff",
    strokeWidth: 1.2,
    d: "M11.4 6c0 2.986-2.432 5.4-5.4 5.4A5.407 5.407 0 0 1 .6 6C.6 3.033 3.034.6 6 .6s5.4 2.433 5.4 5.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "M5.977 3.427v2.468L7.7 7.725"
  })));
};
export default SvgDeliveryExpress;